import { connect } from 'react-redux';
import { fetchChatPermsIfNeeded } from 'common/ducks/user';
import DriftChat from 'common/components/drift_chat';

const mapStateToProps = ({ user, categories }) => {
  return {
    shouldShow: user.canChat,
    user: user.profile_data,
    categories
  };
}

export default connect(mapStateToProps, { fetchChatPermsIfNeeded })(DriftChat);
